
// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { PriceDetailsComponent } from './price-details.component';
import { HotelCurrencyModule } from 'libraries/service/hotel-currency/hotel-currency.module';
import { QuotationService } from 'libraries/hotel/services/quotation/quotation.service';
import { ConfigSharedHotelModule } from 'libraries/service/resources/configuration/config-shared-hotel.module';
import { PricePipesModule } from 'libraries/pipes/price/price-pipes.module';
import { PricePipeModule } from 'libraries/pipes/price/price-pipe.module';
import {GetMainCurrencyModule} from "../../../service/get-main-currency/get-main-currency.module";

@NgModule({
    imports: [
        CommonModule,
        PricePipesModule,
        PricePipeModule,
        HotelCurrencyModule,
        ConfigSharedHotelModule,
        GetMainCurrencyModule
    ],
    exports: [
        PriceDetailsComponent,
    ],
    declarations: [
        PriceDetailsComponent,
    ],
    providers: [
        QuotationService,
    ],
})
export class PriceDetailsModule { }
